import * as Sentry from "@sentry/nextjs";
import { deleteBookedOffer } from '../../../app/api/deleteBookedOfferAPI';
import { BaseAction } from "../../../core/actions/BaseAction";
import { IDeleteShuttleOfferActionParams } from '../../../Orchestrator/Types/Interface/ActionParams/UpcomingPastBookingActionParams';


class DeleteShuttleBookOfferAction extends BaseAction<{ result: string, data: any }, IDeleteShuttleOfferActionParams> {

    override async run(): Promise<{ result: string, data: any }> {
        const { bookingId, offerId } = this.params ?? {};
        try {
            if (!bookingId || !offerId) {
                return { result: "false", data: [] };
            }

            const response: any = await deleteBookedOffer(bookingId, offerId);
            if (response.status === "ok") {
                return { result: "true", data: response.answer ?? [] };
            }

            Sentry.captureMessage("DeleteShuttleBookOfferAction: delete rejected", {
                level: "warning",
                tags: { action: "DeleteShuttleBookOfferAction" },
                extra: { bookingId, offerId, response },
            });
            return { result: "false", data: response };
        } catch (error: any) {
            console.error("Error deleting booked shuttle offer:", error);
            Sentry.captureException(error, {
                tags: { action: "DeleteShuttleBookOfferAction" },
                extra: { bookingId, offerId },
            });
            return { result: "false", data: [] };
        }
    }
}

export const deleteShuttleBookOfferAction = new DeleteShuttleBookOfferAction()
